import { Injectable } from '@angular/core';

import { IBetslipState } from '../../../../../base/store/state';
import { BetslipType } from '../../../../../core/betslip-type';
import { BetslipPick } from '../../../../../core/picks/betslip-pick';
import { PickValidationContext } from '../../../models/models';
import { RewardTokensContextGeneratorService } from './reward-tokens-context-generator.service';

@Injectable()
export class PickContextGeneratorService {
    constructor(private rewardTokensGenerator: RewardTokensContextGeneratorService) {}

    generateContext(pick: BetslipPick, state: IBetslipState): PickValidationContext {
        return {
            settings: {
                oddsAcceptance: state.settings.oddsAcceptance,
            },
            rewardTokens: this.rewardTokensGenerator.generateContext(state.rewardTokens, state.types, {
                betslipType: BetslipType.Single,
                pickId: pick.id,
            }),
        };
    }
}
